// import datepickerFactory from 'jquery-datepicker';
// import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';

//---------------------------
//datepicker起動
//---------------------------
// datepickerFactory($);
// datepickerJAFactory($);
// $(".js-datepicker").each(function(index) {
//   $.datepicker.regional['ja'];
// });


//---------------------------
//戻るボタンクリック
//---------------------------
// $(".wpcf7c-btn-back").click(function() {
//   $('.wpcf7-form').removeClass('custom-wpcf7c-confirmed');
// });

const wpcf7Elm = document.querySelector( '.wpcf7' );

if(wpcf7Elm) {
  const position = $('form.wpcf7-form').offset().top;
  wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
    let speed = 1000;
    jQuery("html, body").animate({scrollTop:position}, speed, "swing");
  }, false );
}
 
